import { render, staticRenderFns } from "./CenterStake.vue?vue&type=template&id=f99cadd6&scoped=true"
import script from "./CenterStake.vue?vue&type=script&lang=js"
export * from "./CenterStake.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f99cadd6",
  null
  
)

/* custom blocks */
import block0 from "./CenterStake.vue?vue&type=custom&index=0&blockType=vue-filename-injector"
if (typeof block0 === 'function') block0(component)

export default component.exports